import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import useCampaignCreationStore from '@/features/campaign-creation/model/store'
import { useInviteLinksStore } from '@/features/analytics/model'
import { getHistoryTree } from '@/app/routers/history-store/history-tree-store'

export const useLogout = () => {
    const navigate = useNavigate()
    const { resetForm } = useCampaignCreationStore()
    const { resetInviteLinks } = useInviteLinksStore()

    const logout = useCallback(() => {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        getHistoryTree().reset()

        resetForm()
        resetInviteLinks()

        navigate('/login')
    }, [navigate, resetForm, resetInviteLinks])

    return logout
}
